    <div class="overlay" #overDiv>
      <!-- <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" >Please Wait.. Loading... </p></ngx-spinner> -->
      <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-pulse"
        [fullScreen]="true">
        <p style="color: white"> {{"Please-Wait" | translate}}... {{"Loading" | translate}}... </p>
      </ngx-spinner>
    </div>
